module.exports = __webpack_public_path__ + "img/mob1.d37cd731.png";